import { render, staticRenderFns } from "./mediaPosition.vue?vue&type=template&id=a912f7b0&scoped=true"
import script from "./mediaPosition.vue?vue&type=script&lang=js"
export * from "./mediaPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912f7b0",
  null
  
)

export default component.exports